import React from 'react';

/* eslint-disable max-len */
const TechIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M4.20459 2.52148H27.795V18.0735H4.20459V2.52148Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4769 29.5304L1.56812 29.5112C2.60172 25.7224 3.41132 21.8824 4.24972 18.0488L27.7537 18.068C28.5889 21.9048 29.5553 25.7128 30.4769 29.5304Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47363 20.9238H7.48163H6.47363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47363 20.9238H7.48163",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1216 20.9375H11.1328H10.1216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1216 20.9375H11.1328",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.76 20.9473H14.768H13.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.76 20.9473H14.768",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4241 20.9609H18.4321H17.4241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4241 20.9609H18.4321",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0718 20.9688H22.0798H21.0718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0718 20.9688H22.0798",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7231 20.9785H25.7311H24.7231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7231 20.9785H25.7311",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99072 23.8047H7.04032H5.99072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99072 23.8047H7.04032",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83374 23.8184H10.8961H9.83374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83374 23.8184H10.8961",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6799 23.8301H14.7423H13.6799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6799 23.8301H14.7423",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5264 23.8438H18.5888H17.5264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5264 23.8438H18.5888",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3694 23.8555H22.4318H21.3694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3694 23.8555H22.4318",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2161 23.8691H26.2785H25.2161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2161 23.8691H26.2785",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 26.6973H6.58875H5.46875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 26.6973H6.58875",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52002 26.707L22.784 26.7422L9.52002 26.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52002 26.707L22.784 26.7422",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7151 26.748H26.8319H25.7151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7151 26.748H26.8319",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0354 12.2179L17.261 6.92188",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4929 12.8868L24.0609 6.25",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 13.6761L22.672 10.2969",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export { TechIcon };
